import { ActionType } from 'typesafe-actions'

import { PUSH_NOTIFICATION, REMOVE_LAST_FROM_QUEUE } from 'actions/notifications-actions'

import * as actions from 'actions/notifications-actions'
import { InteractiveNotification, Player } from 'types/global'

type NotificationsAction = ActionType<typeof actions>

export type State = Readonly<{
  watchlists: { queue: InteractiveNotification<{ player: Player }>[]; counter: number }
}>

const initialState: State = {
  watchlists: { queue: [], counter: 0 },
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: NotificationsAction): State {
  switch (action.type) {
    case PUSH_NOTIFICATION:
      state[action.payload.key].queue.unshift(action.payload.notification)
      state[action.payload.key].counter = state[action.payload.key].counter + 1
      return { ...state }
    case REMOVE_LAST_FROM_QUEUE:
      state[action.payload].queue.pop()
      return { ...state }
    default:
      return state
  }
}
